import React from 'react';
import {
    Box,
    Button,
    Flex,
    Image,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalOverlay,
    Text
} from '@chakra-ui/react';
import { useTranslate } from 'ts/common/hooks';

interface PaymentConfirmationModalProps {
    isOpen: boolean;
    onClose: () => void;
    invoice: SpApi.Client.IInvoice;
}

const PaymentConfirmationModal: React.FC<PaymentConfirmationModalProps> = ({
    isOpen,
    onClose,
    invoice
}) => {
    const t = useTranslate('clientInvoice');

    // Get the brand logo URL from the invoice (use emailBrandLogo for invoices)
    const brandLogoUrl = invoice.brandTheme?.emailBrandLogo?.displayUrl?.original;
    const logoAltText = invoice.brandTheme?.logoAltText || invoice.brandName;

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered size="lg">
            <ModalOverlay />
            <ModalContent bg="modalBackground">
                <ModalBody padding="48px">
                    <Flex flexDirection="column" alignItems="center" gap="24px">
                        {/* Brand Logo */}
                        {brandLogoUrl && (
                            <Box maxWidth="200px" maxHeight="100px">
                                <Image
                                    src={brandLogoUrl}
                                    alt={logoAltText}
                                    maxWidth="100%"
                                    maxHeight="100px"
                                    objectFit="contain"
                                />
                            </Box>
                        )}

                        {/* Payment Confirmed Heading */}
                        <Text
                            fontSize="24px"
                            fontWeight="semibold"
                            color="brand.primary"
                            textAlign="center"
                        >
                            {t('paymentConfirmed')}
                        </Text>

                        {/* Payment Confirmation Message */}
                        {invoice.paymentConfirmationText && (
                            <Text
                                fontSize="14px"
                                lineHeight="1.6"
                                textAlign="left"
                                whiteSpace="pre-wrap"
                                width="100%"
                                color="text"
                            >
                                {invoice.paymentConfirmationText}
                            </Text>
                        )}
                    </Flex>
                </ModalBody>
                <ModalFooter justifyContent="center">
                    <Button onClick={onClose} variant="ghost">
                        {t('close')}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default PaymentConfirmationModal;
